<template>
    <div class="desk-layout flex-grow-1 d-flex flex-column">
        <global-background />
        <global-messenger />

        <div class="desk-layout__header">
            <slot name="header"></slot>
        </div>

        <div class="desk-layout__main flex-grow-1 flex-column d-flex">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import GlobalBackground from '@/components/desk-global/global-background/global-background';
import GlobalMessenger from '@/components/desk-global/global-messenger/global-messenger';
export default {
    name: 'DeskGlobal',
    components: { GlobalMessenger, GlobalBackground },
    computed: {
        /**
         * @type {string}
         */
        background() {
            return this.$store.state.desk.background;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../styles/var';

.desk-layout {
    &__header {
        z-index: $desk-header-zindex;
    }

    &__main {
        z-index: $desk-main-zindex;
    }
}
</style>
